import { useState, useEffect } from 'react';
export function usePageZoom() {
  let zoomPercent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 150;
  const [zoomLevel, setZoomLevel] = useState(1);
  const [zoomedDPR, setZoomedDPR] = useState(1);
  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    const zoomFactor = window.outerWidth / window.innerWidth;
    const currentDPR = window.devicePixelRatio;
    const baseDPR = parseFloat((currentDPR / zoomFactor).toFixed(2));
    const getZoomLevel = () => {
      return Math.round(window.devicePixelRatio * 100);
    };

    // get zoom initial value per 100% page zoom
    const calculateZoomedDevicePixelRatio = () => {
      const basedZoom = Math.round(baseDPR * 100);
      const definiteZoom = Math.round(zoomPercent * basedZoom / 100);
      setZoomedDPR(definiteZoom);
    };
    calculateZoomedDevicePixelRatio();
    setZoomLevel(getZoomLevel());
    const handleResize = () => {
      setZoomLevel(getZoomLevel());
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return {
    zoomLevel,
    zoomedDPR
  };
}